// @ts-nocheck
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { IconButton } from '@material-ui/core';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName, getHeaderColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  tableColumnHeader: {
    display: 'flex',
    flexDirection: 'row',
  },
  tableColumnHeaderText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  rowHovered: {
    cursor: 'pointer',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, roles: state.roles, themeName: state.settings.items.theme.data.themeName }))
class RolesTableView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { 
      classes, 
      roles: { 
        selectedRole,
        roles: { 
          content: rolesData, 
          pagination: { 
            number: currentPage, 
            size, 
            totalPages, 
            totalElements 
          }
        }
      }, 
      themeName,
      onFetchRolesOnPage,
      onSelectRole,
      onRefreshRoles,
      onNewRole
    } = this.props;

    const headerColor = getHeaderColorFromThemeName(themeName);

    return (
      <div className="list-view details-section" style={{ top: 150, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(rolesData) ? (
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}>
                          <Entity entity="rolesAndPermissions" />
                        </h3>
                        <IconButton onClick={() => onRefreshRoles()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="rolesTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchRolesOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          lastPage={totalPages - 1}
                          iconColor="#3f3f3f"
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchRolesOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell colSpan={2}>
                      <h4 className={classes.tableColumnHeaderText}>
                        <Entity entity="roleName" />
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(rolesData, (role) => (
                    <TableRow
                      key={role.id}
                      className={classes.row}
                      hover
                      classes={{
                        selected: classes.rowSelected,
                        hover: classes.rowHovered,
                      }}
                      onClick={() => onSelectRole(role)}
                      selected={selectedRole && selectedRole.id === role.id}
                    >
                      <TableCell colSpan={2}>
                        <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{role.label}</h5>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="rolesTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchRolesOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          iconColor="#3f3f3f"
                          onChangePage={(event, page) => onFetchRolesOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
          ) : (
            <EmptyView
              title="noRoles"
              iconName="icon-simple-line-icons-user"
              subtitle="startAddRoles"
              onNewEntity={() => onNewRole()}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(RolesTableView); 